import {createReducer, on} from '@ngrx/store';
import {saveDataSuggests} from '../actions/utils.actions';

export interface iUtilsState{
  items: []
}

export const initialState: iUtilsState = {
  items: []
};

const _setUtilsReducer = createReducer(
  initialState,
  on(saveDataSuggests, (state, data) => {
    return {...state, items: data.items}
  }),
);

export function setUtilsReducer(state, action) {
  return _setUtilsReducer(state, action);
}